const testimonials = [
  {
    name: 'Marek Kowalski',
    handle: '@marek_k',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20friendly%20young%20polish%20man%20in%20his%20late%20twenties%20with%20short%20brown%20hair%20and%20a%20warm%20genuine%20smile%2C%20wearing%20a%20navy%20crewneck%20sweater%2C%20soft%20natural%20window%20light%20against%20a%20muted%20sage%20green%20wall%2C%20candid%20lifestyle%20portrait%2C%20shallow%20depth%20of%20field%2C%20warm%20authentic%20feel&width=100&height=100&seq=testi-v2-01&orientation=squarish',
    text: 'Kakobuy Spreadsheet całkowicie zmienił sposób, w jaki robię zakupy online. Wszystkie kategorie w jednym miejscu — to ogromna oszczędność czasu. Polecam każdemu, kto ceni sobie wygodę.',
  },
  {
    name: 'Anna Nowak',
    handle: '@anna_nowak',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20polish%20woman%20with%20auburn%20wavy%20hair%20and%20subtle%20freckles%2C%20gentle%20relaxed%20smile%2C%20wearing%20a%20cream%20knit%20cardigan%2C%20soft%20golden%20hour%20lighting%20against%20a%20warm%20terracotta%20textured%20wall%2C%20natural%20beauty%20photography%2C%20authentic%20expression%2C%20no%20makeup%20look&width=100&height=100&seq=testi-v2-02&orientation=squarish',
    text: 'Szukałam wygodnego sposobu na przeglądanie produktów i ten arkusz jest dokładnie tym, czego potrzebowałam. Przejrzysty, szybki i intuicyjny.',
  },
  {
    name: 'Piotr Wiśniewski',
    handle: '@piotr_w',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20confident%20young%20man%20with%20well-groomed%20dark%20beard%20and%20stylish%20round%20eyeglasses%2C%20calm%20thoughtful%20expression%2C%20wearing%20an%20olive%20henley%20shirt%2C%20soft%20studio%20lighting%20against%20a%20deep%20charcoal%20grey%20background%2C%20editorial%20menswear%20portrait%2C%20sharp%20detail%2C%20modern%20masculine%20aesthetic&width=100&height=100&seq=testi-v2-03&orientation=squarish',
    text: 'Jako osoba, która regularnie kupuje online, doceniam przejrzystość i organizację. Kakobuy Spreadsheet to narzędzie, którego używałem od miesięcy i nigdy mnie nie zawiodło.',
  },
  {
    name: 'Katarzyna Lewandowska',
    handle: '@kasia_lew',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20cheerful%20young%20woman%20with%20long%20blonde%20braid%20and%20bright%20blue%20eyes%2C%20radiant%20smile%2C%20wearing%20a%20linen%20oversized%20white%20shirt%2C%20outdoor%20natural%20light%20with%20soft%20bokeh%20greenery%20background%2C%20summer%20lifestyle%20portrait%2C%20fresh%20and%20approachable%20vibe%2C%20high%20detail&width=100&height=100&seq=testi-v2-04&orientation=squarish',
    text: 'Uwielbiam różnorodność kategorii! Od butów po perfumy — wszystko jest świetnie zorganizowane. Zdecydowanie najlepszy arkusz zakupowy, z jakiego korzystałam.',
  },
  {
    name: 'Tomasz Zieliński',
    handle: '@tomek_z',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20athletic%20young%20man%20with%20short%20cropped%20hair%20and%20a%20warm%20friendly%20grin%2C%20wearing%20a%20heather%20grey%20t-shirt%2C%20soft%20diffused%20lighting%20in%20a%20modern%20loft%20apartment%20with%20exposed%20brick%20wall%20behind%20him%2C%20urban%20lifestyle%20portrait%2C%20casual%20authentic%20energy%2C%20natural%20skin%20texture&width=100&height=100&seq=testi-v2-05&orientation=squarish',
    text: 'Bezpieczeństwo zakupów to dla mnie priorytet, a Kakobuy Spreadsheet daje mi pewność, że wszystkie linki prowadzą do sprawdzonych sprzedawców. Świetna robota!',
  },
  {
    name: 'Magdalena Wójcik',
    handle: '@magda_wojcik',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20elegant%20young%20woman%20with%20dark%20bob%20haircut%20and%20subtle%20gold%20hoop%20earrings%2C%20soft%20knowing%20smile%2C%20wearing%20a%20rust%20colored%20turtleneck%20sweater%2C%20soft%20overhead%20natural%20light%20against%20a%20warm%20blush%20pink%20plaster%20wall%2C%20fashion%20editorial%20portrait%2C%20sophisticated%20yet%20approachable%20mood%2C%20fine%20art%20quality&width=100&height=100&seq=testi-v2-06&orientation=squarish',
    text: 'Odkąd zaczęłam korzystać z tego arkusza, moje zakupy stały się o wiele przyjemniejsze. Szczególnie doceniam sekcję poradników — są naprawdę pomocne dla początkujących.',
  },
];

export default function Testimonials() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-3">
          <span className="inline-block bg-accent-100 text-accent-700 text-xs font-label font-bold px-3 py-1.5 rounded-full">
            Opinie Użytkowników
          </span>
        </div>

        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 max-w-[600px] leading-tight">
          Zaufanie Społeczności<br />
          Kakobuy Spreadsheet
        </h2>

        <div className="mt-12 columns-1 md:columns-2 lg:columns-3 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="break-inside-avoid mb-5 bg-white rounded-lg p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-accent-100">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="font-label font-bold text-foreground-900 text-sm">{t.name}</div>
                  <div className="text-foreground-400 text-xs">{t.handle}</div>
                </div>
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed">
                &ldquo;{t.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}